import type { PiclickWP } from '@/types/piclick';

export function getPiclickData(): PiclickWP | null {
  if (typeof window === 'undefined') {
    return null;
  }
  return window.piclickWP ?? null;
}
